import React from 'react';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function FaqSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-62" data-mp="1pllc4hmmighp">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-63" data-mp="1bm3fjg335yxs">
        <HelpCircleIcon className="h-8 w-8 text-petrol" aria-hidden="true" data-id="element-64" data-mp="1gjc3xyetuz7h" />
        <h2 id="faq-title" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-65" data-mp="1glgcitno8me3">
          Lo que más nos preguntan antes de comprar
        </h2>

        <div className="mt-10 divide-y divide-beige-deep border-y border-beige-deep" data-id="element-66" data-mp="1ujwgwdy2a0t2">
          {faqItems.map((item, index) => <details key={item.question} className="group" open={index === 0} data-id="element-67" data-mp="1zgwq2xq7jjoe" data-mpi={index}>
              <summary className="flex cursor-pointer list-none items-start justify-between gap-4 py-5 font-display text-lg font-bold text-petrol transition-colors duration-150 ease-out hover:text-sage-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage" data-id="element-68" data-mp="2n70sx2vknfec">
                {item.question}
                <ChevronDownIcon className="mt-1 h-5 w-5 shrink-0 text-body-muted transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-69" data-mp="10rm4ng7xc3hn" />
              </summary>
              <div className="space-y-3 pb-6 pr-8 text-base leading-relaxed text-body" data-id="element-70" data-mp="1oihzkm7ofet4">
                {item.answer.map(paragraph => <p key={paragraph} data-id="element-71" data-mp="1jjx22ujt798d">{paragraph}</p>)}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}